import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppGlobals } from '@app/app.global';
@Injectable({
  providedIn: 'root'
})
export class BankingService {

  constructor(
    private http: HttpClient,
    private appGlobals: AppGlobals
  ) { }

  addKYC(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}kyc/add`, requestBody);
  }

  getKYC() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}kyc/detail`);
  }

  getFirmTypeList() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}kyc/kyc-documents-list`);
  }

  uploadKYCDoc(requestBody, firmType?: string) {
    let additionalFlag = firmType ? { params: { 'firmType': firmType } } : {};
    return this.http.post(`${this.appGlobals.bypassApiUrl.payment}kyc/document-upload`, requestBody, additionalFlag);
  }

  sendOTP(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}kyc/send-otp`, requestBody);
  }

  verifyOTP(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}kyc/verify-otp`, requestBody);
  }

  getSupplierBalanceDetail() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}supplier/balance-detail`);
  }

  getSuppliers(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}supplier/list`, {
      params: queryParams
    })
  }

  getSupplierAllInvoice(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}supplier/all-invoice`, {
      params: queryParams
    })
  }

  getBeneficiaryList(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}beneficiary-list`, {
      params: queryParams
    })
  }

  getAllBeneficiaryList() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}all-beneficiary-list`)
  }

  getBeneficiaries(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}beneficiary-list`, {
      params: queryParams
    })
  }

  createTransaction(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/create-transaction`, requestBody);
  }

  supplierCashTransaction(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/supplier-cash-transaction`, requestBody);
  }

  // supplierCashPayment(requestBody) {
  //   return this.http.post(`${this.appGlobals.apiUrl.payment}payment/supplier-cash-payment`, requestBody);
  // }

  makePayment(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/make-payment`, requestBody);
  }

  createBeneficiary(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}create-beneficiary`, requestBody);
  }

  createMultipleBeneficiary(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}create-multiple-beneficiary`, requestBody);
  }

  getFailedMultipleBeneficiary() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}failed-multiple-beneficiary`);
  }

  verifyMultipleBeneficiaryOTP(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}verify-multiple-beneficiary`, requestBody);
  }

  verifyBeneficiaryOTP(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}beneficiary-verify-otp`, requestBody);
  }

  getSuppliersForDropdown() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}supplier/suppliers`);
  }
  getTransactionsList(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}payment/transaction-list`, { params: queryParams });
  }

  getInvoicesBySeller(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}supplier/invoices`, {
      params: queryParams
    });
  }

  getOwnerBalance() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}supplier/balance-detail`);
  }

  getPaymentInvoiceLogs(invoice) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}payment/invoice/` + invoice);
  }

  adjustPayment(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/adjust-payment`, requestBody);
  }

  withoutKYCPayment(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/without-kyc-payment`, requestBody);
  }

  uploadKYCDocCancelledCheque(requestBody, firmType?: string) {
    return this.http.post(`${this.appGlobals.bypassApiUrl.payment}kyc/document-upload-cancelled-cheque`, requestBody);
  }

  deleteUploadedKycDocument(requestBody) {
    return this.http.delete(`${this.appGlobals.apiUrl.payment}kyc/delete-kyc-document`, { body: requestBody });
  }

  updateKYCMessageStatus(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}kyc/kyc-message-status-update`, requestBody);
  }

  updateBeneficiary(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}beneficiary-status-update`, requestBody);
  }

  getDashboardMonitoring(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}dashboard/monitoring`, { params: queryParams });
  }

  getActiveUsers(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}dashboard/active-users`, { params: queryParams });
  }

  getInActiveUsers(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}dashboard/inactive-users`, { params: queryParams });
  }

  getDormantUser(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}dashboard/dormant-user`, { params: queryParams });
  }

  getKycApprovedUser(queryParams = {}) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}dashboard/kyc-approved-user`, { params: queryParams });
  }

  updateBeneficiaryDetails(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}update-beneficiary`, requestBody);
  }

  reSendOtp(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/resend-otp`, requestBody);
  }

  beneficiaryResendOTP(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}beneficiary-resend-otp`, requestBody);
  }

  multipleBeneficiaryResendOTP(requestBody) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}multiple-beneficiary-resend-otp`, requestBody);
  }

  failedMultipleBeneficiary() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}failed-multiple-beneficiary`);
  }

  adjustPaymentList(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}payment/adjust-payment-list`, { params: queryParams });
  }

  adjustMultiplePayment(body) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/adjust-multiple-payment`, body);
  }

  adjustPaymentTransaction(params) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}payment/adjust-payment-transaction`, { params });
  }

  updateBulkPaymentLogs(body) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/update-bulk-payment-logs`, body);
  }

  bulkPaymentStatusCheck() {
    return this.http.get(`${this.appGlobals.apiUrl.payment}payment/update-bulk-payment-status`);
  }

  getAccountDashboard(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}dashboard/accounts-dashboard`, { params: queryParams });
  }

  getSupplier(queryParams) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}dashboard/company-supplier`, { params: queryParams });
  }

  getRelevantSupplier(supplier) {
    return this.http.get(`${this.appGlobals.apiUrl.payment}supplier/relevant-supplier`, { params: { supplier } });
  }

  updateMarkAsUnpaid(body) {
    return this.http.post(`${this.appGlobals.apiUrl.payment}payment/invoice-mark-as-unpaid`, body);
  }
}
